export type EmailItem = {
  key: string
  name: string
  description: string
}

export const emails: EmailItem[] = [
  {
    key: 'reportCompletion',
    name: 'Report Completion Email',
    description:
      'The email sent when the user completes the final step of their monthly report.',
  },
]
